import { put, call } from 'redux-saga/effects';
import configTypes from './config.types';
import NeurolyticsAPI from 'services/NeurolyticsAPI';
import Logger from '../../services/Logger';

export function* fetchPublicScansConfig(action) {
    const { companySlug, assessmentId, invitationId, navigate } =
        action.payload;
    try {
        const response = yield call(
            [NeurolyticsAPI, 'fetchPublicScansConfigApi'],
            assessmentId,
            invitationId,
        );
        yield put({
            type: configTypes.FETCH_PUBLIC_SCANS_CONFIG_SUCCESS,
            payload: {
                companySlug,
                companyName: response.companyName,
                defaultLanguage: response.language,
                logoUrl: response.logoUrl,
                groupName: response.groupName,
            },
        });
    } catch (error) {
        yield put({
            type: configTypes.FETCH_PUBLIC_SCANS_CONFIG_FAILURE,
            payload: {
                error,
            },
        });
        navigate('/404');
    }
}

export function* fetchConfig(action) {
    try {
        const { assessmentId, targetGroupId, invitationId } = action.payload;
        const {
            companySlug,
            companyName,
            companyLogoUrl,
            targetGroupName,
            modules,
            language,
            assessmentName,
            description,
            autoAnalysis,
            dataCollection,
            isCompleted,
            groupRelations,
        } = yield call(
            [NeurolyticsAPI, 'fetchConfigApi'],
            assessmentId,
            invitationId,
        );

        yield put({
            type: configTypes.FETCH_PUBLIC_SCANS_CONFIG_SUCCESS,
            payload: {
                companySlug,
                companyName,
                defaultLanguage: language,
                logoUrl: companyLogoUrl,
                groupName: targetGroupName,
            },
        });

        yield put({
            type: configTypes.FETCH_CONFIG_SUCCESS,
            payload: {
                assessmentId,
                invitationId,
                targetGroupId,
                targetGroupName,
                companySlug,
                modules,
                language,
                assessmentName,
                description,
                autoAnalysis,
                dataCollection,
                isCompleted,
                groupRelations,
            },
        });
    } catch (error) {
        yield put({
            type: configTypes.FETCH_CONFIG_FAILURE,
            payload: {
                error,
            },
        });
    }
}

export function* storeScanPreferencesEffect(action) {
    const { assessmentId, invitationId, isOptOut } = action.payload;
    try {
        yield call(
            [NeurolyticsAPI, 'storeScanPreferencesApi'],
            assessmentId,
            invitationId,
            isOptOut,
        );
        yield put({
            type: configTypes.STORE_SCAN_PREFERENCES_SUCCESS,
            payload: {
                invitationId: invitationId,
                isOptOut: isOptOut,
            },
        });
    } catch (error) {
        yield put({
            type: configTypes.STORE_SCAN_PREFERENCES_FAILURE,
            payload: {
                error,
            },
        });
    }
}

export function* finishScan(action) {
    const { assessmentId, invitationId } = action.payload;

    try {
        yield call(
            [NeurolyticsAPI, 'finishScanApiCall'],
            assessmentId,
            invitationId,
        );
        Logger.logInfo(
            `AssessmentController - Scan completion requested for invitationId: ${invitationId}`,
        );
        Logger.logInfo('Assessment DONE');
        yield put({
            type: configTypes.FINISH_SCAN_SUCCESS,
        });
    } catch (error) {
        Logger.logError(
            `AssessmentController - Failed to request scan completion for invitationId: ${invitationId}`,
            error,
        );

        yield put({
            type: configTypes.FINISH_SCAN_FAILURE,
            payload: {
                error,
            },
        });
    }
}
